import { gql } from '__generated__';

export default gql(`
  mutation DeleteParticipantFieldImport($id: ID!) {
    deleteParticipantFieldImport(id: $id)
  }
`);
